var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplay10Icon = function SvgReplay10Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "replay10Icon_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#replay10Icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M12 15.333h-1a.97.97 0 0 1-.717-.283.97.97 0 0 1-.283-.717q0-.433.283-.716a.97.97 0 0 1 .717-.284h2q.434 0 .717.284a.97.97 0 0 1 .283.716v6a.97.97 0 0 1-.283.717.97.97 0 0 1-.717.283.97.97 0 0 1-.717-.283.97.97 0 0 1-.283-.717zm4.667 6a1.3 1.3 0 0 1-.95-.383 1.3 1.3 0 0 1-.384-.95v-5.333q0-.567.384-.95a1.3 1.3 0 0 1 .95-.384h2.666q.567 0 .95.384.384.383.384.95V20q0 .567-.384.95a1.3 1.3 0 0 1-.95.383zm.666-2h1.334v-4h-1.334zm-1.333 10q-2.5 0-4.683-.95a12.2 12.2 0 0 1-3.8-2.566 12.2 12.2 0 0 1-2.567-3.8Q4 19.833 4 17.333q0-.566.383-.95a1.3 1.3 0 0 1 .95-.383q.567 0 .95.383.384.384.384.95 0 3.9 2.716 6.617T16 26.667t6.617-2.717q2.715-2.717 2.716-6.617 0-3.9-2.716-6.616Q19.9 8 16 8h-.2l1.133 1.133q.4.4.384.934a1.4 1.4 0 0 1-.384.933 1.36 1.36 0 0 1-.95.417 1.24 1.24 0 0 1-.95-.384L11.6 7.6a1.28 1.28 0 0 1-.4-.933q0-.534.4-.934L15.033 2.3q.4-.4.95-.383.55.016.95.416.368.4.384.934.016.533-.384.933L15.8 5.333h.2q2.5 0 4.683.95a12.2 12.2 0 0 1 3.8 2.567 12.2 12.2 0 0 1 2.567 3.8q.95 2.184.95 4.683 0 2.5-.95 4.684a12.2 12.2 0 0 1-2.567 3.8 12.2 12.2 0 0 1-3.8 2.566q-2.183.95-4.683.95"
  }))));
};
export default SvgReplay10Icon;